import PlateLogoIcon from '@/assets/icons/img-logo.svg?react'
import css from './WorkspaceAvatar.module.css'

interface WorkspaceAvatarProps {
    name: string
    avatar?: string | null
    size?: 'medium' | 'big'
    className?: string
}

const WorkspaceAvatar = ({ name, avatar, size = 'big', className }: WorkspaceAvatarProps) => {
    const sizeClass = size === 'medium' ? css.medium : css.big

    return (
        <div className={[css.avatar, sizeClass, avatar && css.has_image, className].filter(Boolean).join(' ')} data-has-image={avatar ? 'true' : undefined}>
            {avatar ? (
                <img src={avatar} alt={name} className={css.image} />
            ) : (
                <PlateLogoIcon className={css.logo} />
            )}
        </div>
    )
}

export default WorkspaceAvatar
